// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { GeneralObject } from "@vocollege/app/dist/global";
import {
  DownloadExcelButtonProps,
  Sheet,
} from "@vocollege/components/dist/DownloadExcelButton";
import { getStatisticsTotal } from "services/Utils";

export const sortByTitle = (a: any, b: any) => {
  if (!a?.title || !b?.title) {
    return 0;
  }
  if (a.title < b.title) {
    return -1;
  }
  if (a.title > b.title) {
    return 1;
  }
  return 0;
};

export const sortByLabel = (
  a: any,
  b: any,
  data: null | GeneralObject = null
) => {
  if (!data) {
    return 0;
  }
  let aLabel = data[a]?.label;
  let bLabel = data[b]?.label;
  if (!aLabel || !bLabel) {
    return 0;
  }
  if (aLabel < bLabel) {
    return -1;
  }
  if (aLabel > bLabel) {
    return 1;
  }
  return 0;
};

export const getSummaryEducatorType = (parsedData: any) => {
  const result: GeneralObject = [];
  parsedData.forEach((v: GeneralObject) => {
    v.items.forEach((v: GeneralObject) => {
      if (!("educator_type" in v)) {
        return;
      }
      let educatorType = JSON.parse(v.educator_type);
      if (educatorType) {
        educatorType.forEach((educatorType: GeneralObject) => {
          let key = `${educatorType}`;

          if (!(key in result)) {
            result[key] = {
              label: I18n.get.group.educatorTypes[key],
              note: "",
              value: 0,
            };
          }
          result[key].value += v.total;
        });
      }
    });
  });
  return Object.keys(result)
    .sort()
    .map((v: string) => {
      return {
        label: result[v].label,
        note: result[v].note,
        value: result[v].value,
      };
    });
};

export const getExcelData = (
  data: any,
  parsedData: any,
  variables: any,
  dataCategory: string,
  label: string
) => {
  if (parsedData.length === 0) {
    return null;
  }
  const result: DownloadExcelButtonProps = {
    filename: label.toLowerCase().replaceAll(" ", "_"),
    sheets: [],
  };
  let commonHead = [
    [
      {
        richText: [
          {
            font: {
              size: 16,
              bold: true,
            },
            text: label,
          },
        ],
      },
      "",
      `${I18n.get.misc.created_at} ${data?.[dataCategory].createdAt}\n${variables?.from} - ${variables?.to}`,
    ],
    [
      I18n.trans(I18n.get.vocertStatistics.perItem, {
        item: I18n.get.group.categories[variables?.groupBy].toLowerCase(),
      }),
    ],
    [],
    [
      {
        richText: [
          {
            font: {
              size: 10,
              bold: true,
            },
            text: I18n.get.vocertStatistics.total,
          },
        ],
      },
      "",
      getStatisticsTotal(parsedData),
    ],
  ];

  let summaryEducatorTypeSheet: Sheet = {
    name: I18n.get.vocertStatistics.perEducatorType,
    rows: [...commonHead],
  };

  getSummaryEducatorType(parsedData).forEach((v: GeneralObject, i: number) => {
    summaryEducatorTypeSheet.rows?.push(["", "", ""]);
    let label = v.label;
    if (v.note) {
      label = `${label}\n${v.note}`;
    }
    summaryEducatorTypeSheet.rows?.push([
      {
        richText: [
          {
            font: {
              size: 10,
            },
            text: label,
          },
        ],
      },
      "",
      v.value,
    ]);
  });

  result.sheets?.push(summaryEducatorTypeSheet);

  let byGroupSheet: Sheet = {
    name: I18n.trans(I18n.get.vocertStatistics.perItem, {
      item: I18n.get.group.categories[variables?.groupBy].toLowerCase(),
    }),
    rows: [...commonHead],
  };

  parsedData.forEach((v: GeneralObject) => {
    byGroupSheet.rows?.push(["", "", ""]);

    let title = v.title;

    if (v.note) {
      title = `${title}\n${v.note}`;
    }

    byGroupSheet.rows?.push([
      {
        richText: [
          {
            font: {
              size: 10,
              bold: true,
            },
            text: title,
          },
        ],
      },
      "",
      v.total,
    ]);
  });

  result.sheets?.push(byGroupSheet);

  return result;
};

export const getExcelDataWithChildren = (
  data: any,
  parsedData: any,
  variables: any,
  dataCategory: string,
  label: string
) => {
  if (!data || !parsedData?.items || parsedData?.items?.length === 0) {
    return null;
  }
  const result: DownloadExcelButtonProps = {
    filename: label.toLowerCase().replaceAll(" ", "_"),
    sheets: [],
  };

  let commonHead = [
    [
      {
        richText: [
          {
            font: {
              size: 16,
              bold: true,
            },
            text: label,
          },
        ],
      },
      "",
      `${I18n.get.misc.created_at} ${data[dataCategory]?.createdAt}\n${variables?.from} - ${variables?.to}`,
    ],
    [],
    [],
    [
      {
        richText: [
          {
            font: {
              size: 10,
              bold: true,
            },
            text: I18n.get.vocertStatistics.total,
          },
        ],
      },
      "",
      parsedData.total,
    ],
  ];

  let summarySheet: Sheet = {
    name: I18n.get.vocertStatistics.summary,
    rows: [...commonHead],
  };

  result.sheets?.push(summarySheet);

  let summaryEducatorTypeSheet: Sheet = {
    name: I18n.get.vocertStatistics.perEducatorType,
    rows: [...commonHead],
  };

  summaryEducatorTypeSheet.rows?.push([
    {
      richText: [
        {
          font: {
            size: 10,
          },
          text: I18n.get.vocertStatistics.perEducatorTypeNote,
        },
      ],
    },
    "",
    "",
  ]);

  Object.keys(parsedData.itemsPerEducatorType)
    .sort((a, b) => sortByLabel(a, b, parsedData.itemsPerEducatorType))
    .forEach((key: string) => {
      const education = parsedData.itemsPerEducatorType[key];

      summaryEducatorTypeSheet.rows?.push(["", "", ""]);
      let label = education.label;
      if (education.note) {
        label = `${label}\n${education.note}`;
      }
      summaryEducatorTypeSheet.rows?.push([
        {
          richText: [
            {
              font: {
                size: 10,
              },
              text: label,
            },
          ],
        },
        "",
        education.value,
      ]);
    });

  result.sheets?.push(summaryEducatorTypeSheet);

  let byGroupSheet: Sheet = {
    name: I18n.trans(I18n.get.vocertStatistics.perItem, {
      item: I18n.get.group.categories[variables?.groupBy].toLowerCase(),
    }),
    rows: [...commonHead],
  };

  Object.values(parsedData.items).forEach((v: any) => {
    byGroupSheet.rows?.push(["", "", ""]);

    let title = v.title;

    if (v.note) {
      title = `${title}\n${v.note}`;
    }

    byGroupSheet.rows?.push([
      {
        richText: [
          {
            font: {
              size: 12,
              bold: true,
            },
            text: title,
          },
        ],
      },
      "",
      v.total,
    ]);

    Object.values(v.children).forEach((v: any) => {
      if (variables?.groupBy === "region") {
        byGroupSheet.rows?.push([
          {
            richText: [
              {
                font: {
                  size: 10,
                  bold: true,
                },
                text: v.title,
              },
            ],
          },
          "",
          v.total,
        ]);
      }

      if (variables?.groupBy !== "educator") {
        Object.values(v.educators).forEach((educator: any) => {
          byGroupSheet.rows?.push([
            {
              richText: [
                {
                  font: {
                    size: 8,
                  },
                  text: `- ${educator.title}`,
                },
              ],
            },
            "",
            educator.total,
          ]);
        });
      }
    });
  });

  result.sheets?.push(byGroupSheet);

  return result;
};
